import { useAmplifyREST } from "hooks/useAmplifyREST";
import "./mapPanel.scss";
import {
  Card, Row, Col, CloseButton, Badge
} from "react-bootstrap";
import { Spinner } from "@whitespace/whitespace-ui";
import { IHwrcSiteMapPanelProps } from "interfaces/components/Map/IHwrcSiteMapPanelProps";
import React, { useEffect, useState } from "react";
import IHwrcSiteWorkOrderViewModel from "interfaces/IHwrcSiteWorkOrderViewModel";
import IGetHwrcSiteWorkOrders from "interfaces/Response/IGetHwrcSiteWorkOrders";
import MapWorkOrderPane from "./MapWorkOrderPane";

const HwrcSiteMapPanel = ({
  onClose,
  title,
  id,
  isSendingHandler,
  addToExceptionsHandler
}: IHwrcSiteMapPanelProps) => {
  const [workOrders, setWorkOrders] = useState<IHwrcSiteWorkOrderViewModel[]>(
    []
  );

  const {
    isSending: getHwrcSiteWorkOrdersIsSending,
    errors: getHwrcSiteWorkOrdersErrors,
    data: getHwrcSiteWorkOrdersData,
    sendRequest: getHwrcSiteWorkOrdersSendRequest
  } = useAmplifyREST();

  useEffect(() => {
    if (id) {
      setWorkOrders([]);
      getHwrcSiteWorkOrdersSendRequest(
        `map/hwrcsites/${id}/workorders/incomplete`,
        "GET"
      );
    }
  }, [getHwrcSiteWorkOrdersSendRequest, id]);

  useEffect(() => {
    isSendingHandler(getHwrcSiteWorkOrdersIsSending);
  }, [getHwrcSiteWorkOrdersIsSending, isSendingHandler]);

  useEffect(() => {
    if (getHwrcSiteWorkOrdersErrors) {
      addToExceptionsHandler(getHwrcSiteWorkOrdersErrors);
    }
  }, [getHwrcSiteWorkOrdersErrors, addToExceptionsHandler]);

  useEffect(() => {
    if (getHwrcSiteWorkOrdersData as IGetHwrcSiteWorkOrders) {
      setWorkOrders(getHwrcSiteWorkOrdersData.workOrders);
    }
  }, [getHwrcSiteWorkOrdersData, setWorkOrders]);

  const renderWorkOrders = () => {
    if (workOrders) {
      return React.Children.toArray(
        workOrders.map((workOrder: IHwrcSiteWorkOrderViewModel) => (
          <MapWorkOrderPane
            workOrder={workOrder}
            isVehicle={false}
            sourceId={id}
          />
        ))
      );
    }

    return undefined;
  };

  return (
    <div className="d-flex flex-column map-panel map-panel-border">
      <Card className="flex-grow-1">
        <Card.Header data-testid="hwrcsite-card-header">
          Site Details
          <CloseButton aria-label="Close" variant="white" onClick={onClose} />
        </Card.Header>
        <Card.Body className="side-darawer">
          <Row>
            <Col>
              <strong>
                <span data-testid="site-name">Site Name</span>
              </strong>
            </Col>
          </Row>
          <Row>
            <Col>{title}</Col>
          </Row>
        </Card.Body>
      </Card>
      <Card className="flex-grow-1">
        <Card.Header data-testid="hwrcsite-workorder-header">
          Work Orders
          <Spinner
            animation="grow"
            visible={getHwrcSiteWorkOrdersIsSending}
            spinnerText="Loading"
            variant="info"
          />
          {!getHwrcSiteWorkOrdersIsSending && (
            <Badge className="float-end" data-testid="workorder-count">
              {workOrders && workOrders.length}
            </Badge>
          )}
        </Card.Header>
        <Card.Body
          className="work-orders-overflow-scroll side-darawer"
          style={{ maxHeight: "45vh" }}
        >
          {workOrders && renderWorkOrders()}
        </Card.Body>
      </Card>
    </div>
  );
};

export default HwrcSiteMapPanel;
